import { render, staticRenderFns } from "./statementconciliationhistory.vue?vue&type=template&id=00585a55&scoped=true"
import script from "./statementconciliationhistory.vue?vue&type=script&lang=js"
export * from "./statementconciliationhistory.vue?vue&type=script&lang=js"
import style0 from "./statementconciliationhistory.vue?vue&type=style&index=0&id=00585a55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00585a55",
  null
  
)

export default component.exports